export default __webpack_public_path__ + "static/media/wallet.33857ee3.svg";